import { render, staticRenderFns } from "./AuxiliaryAbnormal.vue?vue&type=template&id=c96fa22a&scoped=true&"
import script from "./AuxiliaryAbnormal.vue?vue&type=script&lang=js&"
export * from "./AuxiliaryAbnormal.vue?vue&type=script&lang=js&"
import style0 from "./AuxiliaryAbnormal.vue?vue&type=style&index=0&id=c96fa22a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96fa22a",
  null
  
)

export default component.exports